<template>
  <el-dialog
    title="标准批量查新"
    :visible.sync="dialogVisible"
    width="600px"
    append-to-body
  >
    <el-form>
      <el-form-item label="下载模板">
        <el-button type="primary" size="small" plain @click="downloadTemplate"
          >下载模板</el-button
        >
      </el-form-item>
      <el-form-item label="上传文件">
        <el-upload
          ref="upload"
          :limit="1"
          accept=".xlsx, .xls"
          :headers="headers"
          :action="uploadurl"
          :disabled="isUploading"
          :on-progress="handleFileUploadProgress"
          :on-success="handleFileSuccess"
          :auto-upload="false"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>

          <div class="el-upload__tip" style="color: red" slot="tip">
            提示：仅允许导入“xls”或“xlsx”格式文件！
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitFileForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { standardBatchSearchTemplate } from "@/api/standardFile";
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    balanceActivityId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      // 上传的地址
      uploadurl:
        process.env.VUE_APP_CDN +
        "/api/unoauth/standard/importSelectStandardFileList",
      // 是否禁用上传
      isUploading: false,
      exportTemplateLoading: false,
    };
  },
  computed: {
    ...mapGetters(["token"]),
    headers() {
      return { Token: this.token };
    },
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // 导出模板
    async downloadTemplate() {
      await this.$confirm("是否确认导出标准批量查新模板?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      this.download(standardBatchSearchTemplate, {}, `标准批量查新模板.xlsx`);
    },
    // 文件上传中处理
    handleFileUploadProgress() {
      this.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response) {
      this.isUploading = false;
      this.$refs.upload.clearFiles();
      const { data, status } = response;
      if (status === 0) {
        this.$emit("uploadSuccess", data);
        this.dialogVisible = false;
      } else {
        this.$message.error("上传失败");
      }
      // console.log(response);
      // this.$emit("refresh");
      // this.dialogVisible = false;
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
  },
};
</script>
